<template>
  <div class="wishlist">
    <section-header class="mt-5 mb-5" title="我的願望清單" subtitle="My Wishlist"/>
    <section>
      <div class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-1 g-5 pb-5" v-if="collectProducts">
        <div class="col" v-for="(product, index) in collectProducts" :key="`product-grid-${index}`">
          <product-grid-item :product="product" class="mb-2"/>
          <button class="btn btn-dark w-100 rounded-0 mb-2 position-relative" data-bs-toggle="modal" data-bs-target="#product-modal" @click="setSelectedProduct(product)">
            <span>加入購物車</span>
            <span class="position-absolute end-0 pe-2"><i class="bi bi-plus"></i></span>
          </button>
          <button class="btn btn-outline-dark rounded-0 w-100 position-relative" @click="onDelClicked(product)">
            <span>刪除</span>
            <span class="position-absolute end-0 pe-2"><i class="bi bi-x"></i></span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import userApi from '@/api/user.js'
import SectionHeader from '@/components/SectionHeader.vue'
import ProductGridItem from '@/components/Product/ProductGridItem.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Wishlist',
  components: {
    SectionHeader,
    ProductGridItem
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters([
      'authId',
      'collects',
      'collectProducts'
    ])
  },
  methods: {
    ...mapMutations([
      'setAlert',
      'signOut',
      'setCollects',
      'setSelectedProduct'
    ]),
    apiGetCollects: function () {
      var self = this
      userApi.getCollects(this.authId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.setCollects(rspData)
      })
    },
    apiDelCollect: function (productId) {
      if (!productId || !this.collects) {
        return
      }
      var self = this
      var collect = this.collects.find(e => e.goodsId === productId)
      if (!collect) {
        return
      }
      userApi.delCollect(collect.recId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `執行發生錯誤：${rspData} (${err})` })
          }
          return
        }
        self.apiGetCollects()
      })
    },
    onDelClicked: function (product) {
      if (!product || !confirm(`刪除商品「${product.goodsName}」？`)) {
        return
      }
      this.apiDelCollect(product.goodsId)
    }
  }
}
</script>

<style scoped>
</style>
